<template>
  <div class="salaries">
    <v-form>
      <v-row>
        <v-col cols="12">
          <v-btn depressed color="primary" :disabled="!canEditSalary" @click="editSalary(null)"
            >New Salary</v-btn
          >
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12">
          <v-btn
            depressed
            color="primary"
            :disabled="!canEditSalary"
            @click="calculateSetDialog = true"
            >Calculate Set</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="salaryList"
            dense
            class="searchResults"
            @click:row="editSalary"
            item-key="SalaryId"
            :items-per-page="-1"
            :loading="loading"
            loading-text="Loading salary list..."
            :single-select="true"
            :calculate-widths="true"
          >
            <template
              v-for="header in headers.filter((header) => header.format !== '')"
              v-slot:[`item.${header.value}`]="{ item, value }"
            >
              {{ formatTableEl(item, value, header.format) }}
            </template>
            <template v-slot:[`item.DateInvested`]="{ item }">
              <span>{{ displayDate(new Date(item.DateInvested)) }}</span>
            </template>
          </v-data-table>

          <Sidebar
            :isShown="isSidebarShown"
            :isNew="isNew"
            :isSalary="true"
            :formElements="formElements"
            :sidebarName="sidebarName"
            :isFormValid="isFormValid"
            :actionsDisabled="!canEditSalary"
            @form-validity="isFormValid = $event"
            @delete="onDelete"
            @cancel="cancelChanges"
            @save="confirmDerivationsDialog"
            @recalculate="recalculateSalaries"
          >
          </Sidebar>
        </v-col>
      </v-row>
    </v-form>
    <Dialog ref="confirmationDialog"></Dialog>
    <v-dialog v-model="derivationsDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          {{ 'Derivations Confirmation' }}
        </v-card-title>
        <v-card-text>
          <div class="mt-3">
            {{ 'This form has some derived values. Do you want to calculate these ?' }}
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="saveChanges(true)"> Yes </v-btn>
          <v-btn color="primary" depressed @click="saveChanges(false)"> No </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="calculateSetDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 lighten-2">
          {{ 'Calculate Set Confirmation' }}
        </v-card-title>
        <v-card-text>
          <div class="mt-3">
            {{ 'Are you sure you want to recalculate all selected members ?' }}
          </div>
        </v-card-text>
        <DatePicker
          label="Please specify the starting date: "
          v-model="calculateSetStartDate"
          class="ml-4"
        ></DatePicker>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="calculateSet"> Yes </v-btn>
          <v-btn color="primary" depressed @click="calculateSetDialog=false;calculateSetStartDate='';"> No </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
import Utils from '@/utils.js';
import Sidebar from '@/components/layout/Sidebar.vue';
import DatePicker from '@/components/formControls/DatePicker.vue';

export default {
  components: { Dialog, Sidebar, DatePicker },
  name: 'Search',

  data() {
    return {
      currentPlan: 0,
      loading: false,
      isSidebarShown: false,
      sidebarName: 'salary',
      formElements: [],
      allElements: [],
      headers: [],
      salaryList: [],
      selectedSalary: null,
      isFormValid: false,
      dialog: false,
      derivationsDialog: false,
      calculateSetDialog: false,
      calculateSetStartDate: "",
    };
  },

  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    isNew() {
      if (this.selectedSalary) return false;
      return true;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
    canEditSalary() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
  },

  watch: {
    memberId() {
      this.getSalaryList();
    },
  },

  created() {
    this.getHeaders();
  },

  mounted: function () {
    if (!this.memberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getForm('Salary');
      this.$root.currentPage = 'Salary';
    }
  },

  methods: {
    displayDate(date) {
      if (date.getFullYear() <= 1900) return null;
      return Utils.getDateStr(date);
    },

    editSalary(item) {
      if (!item && !this.canEditSalary) return;
      this.isSidebarShown = true;
      if (item) {
        this.getSalaryById(item.SalaryId);
      } else {
        this.formElements.forEach((el) => (el.Value = ''));
        this.selectedSalary = null;
      }
    },

    cancelChanges() {
      this.isSidebarShown = false;
      this.selectedSalary = null;
    },

    confirmDerivationsDialog() {
      this.derivationsDialog = true;
    },

    saveChanges(applyDerivations) {
      if (this.isFormValid) {
        this.derivationsDialog = false;
        this.isSidebarShown = false;
        if (this.isNew) {
          this.addSalary(applyDerivations);
        } else {
          this.updateSalary(applyDerivations);
        }
      }
    },

    async onDelete() {
      try {
        await this.$refs.confirmationDialog.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.isSidebarShown = false;
        this.deleteSalary();
      } catch (err) {
        console.log();
      }
    },

    formatTableEl(item, value, format) {
      return Utils.formatTableValue(value, format);
    },

    async calculateSet(){
      this.loading = true;
      try {
        let taggedMembers = this.$store.getters.taggedMembers
        await this.$api.post(`/salary/RecalculateAllSalaries`, {
          startDateString: this.calculateSetStartDate,
          taggedMembers: taggedMembers
        });
        
        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Salaries recalculated',
        });
        
        this.getSalaryList();
      } catch (err) {
        //
      } finally {
        this.calculateSetDialog = false;
        this.calculateSetStartDate = "";
        this.loading = false;
      }
    },

    async recalculateSalaries() {
      this.loading = true;
      try {
        this.formElements.forEach((el) => {
          this.selectedSalary[el.FieldName] = el.Value;
        });
        this.selectedSalary.SalaryDateString = this.selectedSalary.SalaryDate;
        let response = await this.$api.post(`/salary/RecalculateSalaries`, this.selectedSalary);

        if (response.data.Value == -5000) {
          await this.$refs.confirmationDialog.open('Warning', response.data.Msg);
        } else if (response.data.Value == -5010) {
          await this.$refs.confirmationDialog.open('Abort', response.data.Msg);
          return;
        }

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Salaries recalculated',
        });
        this.isSidebarShown = false;
        this.getSalaryList();
      } catch (err) {
        //
      } finally {
        this.loading = false;
      }
    },

    async addSalary(applyDerivations) {
      const newSalary = {};
      this.allElements.forEach((el) => {
        newSalary[el.FieldName] = el.Value;
      });
      this.formElements.forEach((el) => {
        newSalary[el.FieldName] = el.Value;
      });
      newSalary.MembershipID = this.memberId;
      try {
        const response = await this.$api.post(
          `/salary/InsertSalary?applyDerivations=${applyDerivations}&checkMessages=false`,
          newSalary
        );

        if (response.data.Value == -5000) {
          await this.$refs.confirmationDialog.open('Warning', response.data.Msg);
        } else if (response.data.Value == -5010) {
          await this.$refs.confirmationDialog.open('Abort', response.data.Msg);
          return;
        }

        this.$store.commit('setNotificationMessage', { type: 'success', text: 'Salary was added' });
        this.getSalaryList();
      } catch (err) {
        console.log(err.message);
      }
    },

    async updateSalary(applyDerivations) {
      this.loading = true;
      try {
        this.formElements.forEach((el) => {
          this.selectedSalary[el.FieldName] = el.Value;
        });
        this.selectedSalary.SalaryDateString = this.selectedSalary.SalaryDate;
        let response = await this.$api.post(
          `/salary/UpdateSalary?applyDerivations=${applyDerivations}&checkMessages=true`,
          this.selectedSalary
        );

        if (response.data.Value == -5000) {
          await this.$refs.confirmationDialog.open('Warning', response.data.Msg);
          response = await this.$api.post(
            `/salary/UpdateSalary?applyDerivations=${applyDerivations}&checkMessages=false`,
            this.selectedSalary
          );
        } else if (response.data.Value == -5010) {
          await this.$refs.confirmationDialog.open('Abort', response.data.Msg);
          this.loading = false;
          return;
        }

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Salary was updated',
        });
        this.getSalaryList();
      } catch (err) {
        console.log(err.message);
      }
    },

    async deleteSalary() {
      this.loading = true;
      try {
        await this.$api.delete('/salary/DeleteSalary?salaryId=' + this.selectedSalary.SalaryId);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Salary was deleted',
        });
        this.getSalaryList();
      } catch (err) {
        console.log(err.message);
      } finally {
        this.loading = false;
      }
    },

    async getSalaryList() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/salary/GetSalaryList?membershipid=' + this.memberId + '&orderBy=&maxRows=0'
        );

        this.salaryList = response.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async getSalaryById(id) {
      try {
        let response = await this.$api.get('/salary/GetSalaryById?salaryId=' + id);
        this.selectedSalary = response.data;
        var data = response.data;

        if (!response.data) {
          const msg = 'Can not find salary with id ' + id;
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        // match data with form fields
        if (data) Utils.setDataToFormElements(data, this.formElements);
      } catch (err) {
        console.error(err);
      }
    },
    async getForm(formName) {
      try {
        let response = await this.$api.get(
          `/datadictionary/GetFormElements?formName=${formName}&planId=${this.currentPlanId}`
        );

        this.allElements = response.data;
        this.formElements = response.data.filter((f) => f.Visible == true);

        this.getSalaryList();
      } catch (err) {
        console.error(err);
      }
    },
    async getHeaders() {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=Salary&planId=${this.currentPlanId}`
        );

        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
};
</script>

<style lang="scss">
.salaries {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;
}
</style>
